import axios from '../../../axios'

export default {
  getSwitch: function (id, measurementId) {
    return axios
      .get('switch/' + id, {
        params: {
          MeasurementId: measurementId
        }
      })
    // return axios.get('switch/' + id)
  },
  getSwitchAnalysisData: function (id, dtFrom, dtTo) {
    return axios.get('switch/measurements/analysis/' + id, {
      params: {
        dtFrom: dtFrom,
        dtTo: dtTo
      }
    })
  },
  getSwitchSectionAnalysisData: function (id, dtFrom, dtTo) {
    return axios.get('switch/measurements/' + id + '/sectionData', {
      params: {
        dtFrom: dtFrom,
        dtTo: dtTo
      }
    })
  },
  getComplexMeasurementData: function (id, dtFrom, dtTo) {
    return axios.get('switch/measurements/analysis/childMeasurements/' + id, {
      params: {
        dtFrom: dtFrom,
        dtTo: dtTo
      }
    })
  },
  getRailObjectMeasurementDataSummary: function (railObjectId, dtFrom, dtTo) {
    return axios.get('switch/measurements/analysis/summary/railobject/' + railObjectId, {
      params: {
        dtFrom: dtFrom,
        dtTo: dtTo
      }
    })
  },
  getComplexMeasurementDataSummary: function (complexId, dtFrom, dtTo) {
    return axios.get('switch/measurements/analysis/summary/complex/' + complexId, {
      params: {
        dtFrom: dtFrom,
        dtTo: dtTo
      }
    })
  },
  getReferenceData: function (id, dir, engine) {
    return axios.get('switch/measurements/' + id + '/referenceData', {
      params: {
        dir: dir,
        ngn: engine
      }
    })
  },
  getLogBook: function (railObjectId) {
    return axios.get('switch/logbook', {
      params: {
        railObjectId
      }
    })
  },
  getWarningsAndAlarms: function (railObjectId) {
    return axios.get('switch/warningsandalarms', {
      params: {
        railObjectId
      }
    })
  },

  getHealthScoreImage: function (id, dir) {
    return axios.get('switch/measurements/' + id + '/HealthScores', {
      params: {
        dir: dir
      }
    })
  },
  getDetectionsImage: function (id) {
    return axios.get('switch/measurements/' + id + '/detections', {
      params: {}
    })
  },
  getHeatmapImage: function (id, lin) {
    return axios.get('switch/measurements/' + id + '/heatmap', {
      params: {
        lin: lin
      }
    })
  },
  getAnalysisProperties: function () {
    return axios.get('switch/measurements/analysisproperties', {
      params: {}
    })
  },
  getAlarmSetting: function (id) {
    return axios.get('switch/measurements/' + id + '/alarmsetting', {
      params: {}
    })
  },
  resetMonitorStatus: function (dto) {
    return axios.post('switch/resetstatus', dto)
  },
  changeOperationMode: function (dto) {
    return axios.post('switch/changeoperationmode', dto)
  },
  setMaintenanceDate: function (dto) {
    return axios.post('switch/setmaintenancedate', dto)
  },
  insertLogBookItem: function (dto) {
    return axios.post('switch/logbook/', dto)
  },
  getHealthScores: function (id) {
    return axios.get('switch/healthscores/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/switch/SwitchApi.js